module.exports = "<!--a (click)=\"open(formType, user)\">{{formType}}</a-->\n<a (click)=\"open(formType, updateUser)\" tabindex=\"{{tabIndex}}\" attr.aria-label=\"{{formType}} {{updateUserName}}\">{{formType}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/modal-edit.component.html
// module id = ./src/app/modal-edit/modal-edit.component.html
// module chunks = main